import IconButtonsSlider from '@sections/IconButtonsSlider';
import { graphql } from 'gatsby';
import React from 'react';
import { useMicrosite } from '../../contexts/franchise/microsite-context/index.tsx';

const ServicesSlider = ({ data }) => {
    const {
        isMicrosite,
        permalink: micrositePermalink,
        filteredServices
    } = useMicrosite();

    const { services } = data;

    const formattedServiceTypes = filteredServices
        ? filteredServices.map(filteredService => ({ ...filteredService.serviceType, link: { ...filteredService.serviceType.link, href: filteredService.franchiseLink } })) : services;

    const slides = !!formattedServiceTypes && formattedServiceTypes.length > 0
        ? formattedServiceTypes.map((service) => {
            const { title, icon, link, sort } = service;
            const { title: linkTitle, href: linkHref } = link || {};
            const slide = {
                label: title,
                icon,
                link: { href: isMicrosite ? `${micrositePermalink}${linkHref}` : linkHref, title: linkTitle },
                sort,
            };
            return slide;
        }) : [];

    if (slides.length === 0) return null

    return (
        <IconButtonsSlider data={{ slides }} />
    );
};

export const query = graphql`
  fragment ServicesSliderData on CmsPageBuilderBlocks {
    services_slider {
      services {
        title
        link {
          title
          href
        }
        franchise_service_mapping
        icon {
          filename
          title
          url
          contentStackAsset
        }
        sort
      }
    }
  }
`;

export default ServicesSlider;
